import { useQuery } from "@tanstack/react-query"
import React from "react"
import { useParams } from "react-router"
import { getVaultDnsQuery } from "src/auth/auth.model"

const VaultResourceLink = (props: {
  className?: string
  resourceName: string
  resourceId: string
  children: React.ReactNode
}) => {
  const { vaultId, globalSponsorStudyId } = useParams<
    "vaultId" | "globalSponsorStudyId"
  >()
  const query = useQuery({
    ...getVaultDnsQuery({ vaultId: vaultId as string }),
    enabled: !!vaultId && !!globalSponsorStudyId,
    select: (data) => {
      const vaultDns = data.vaultDns
      if (vaultDns) {
        const url = new URL(vaultDns)
        url.pathname = "/ui"
        url.searchParams.set(props.resourceName, props.resourceId)
        return url.toString()
      }
    },
  })

  return (
    <a
      href={query.data}
      className={props.className}
      aria-disabled={!query.data}
    >
      {props.children}
    </a>
  )
}

export default VaultResourceLink
